import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type PostDocumentExternalFilesUploadRequestType,
  postDocumentExternalFilesUpload,
} from '..';
import { queryKey } from './query-key';

export const usePostDocumentExternalFilesUpload = () => {
  const queryClient = useQueryClient();

  const onSuccess = async (
    _data: unknown,
    variables: PostDocumentExternalFilesUploadRequestType,
  ) => {
    await queryClient.refetchQueries(queryKey.document(variables.documentId));
    await queryClient.refetchQueries(
      queryKey.documentsQueue(variables.documentId),
    );
    await queryClient.refetchQueries(
      queryKey.documentsExternalFiles(variables.documentId),
    );
  };

  return useMutation({
    mutationFn: postDocumentExternalFilesUpload,
    onSuccess,
  });
};
